module.exports = __webpack_public_path__ + "img/pagination2-icon.32730804.png";